module.exports = {"meta":{"lead":"בצע את הסקרים שלך"}};